import { GADimension } from '@ps/web-core-enums';
import produce from 'immer';

import { crmZone } from '../entities';
import { TrackingCategory } from '../enums';
import { crmZoneView } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { crmEntity } from '.';

export const CRMViewed = (context: TrackingContextValue, zoneName: string, html: string) => {
  const crmData = crmEntity(zoneName, html);

  if (crmData) {
    const { packageId, packageName } = crmData;

    GAEvent(
      { action: 'Zone Viewed', label: zoneName, value: packageId },
      { category: TrackingCategory.CRM },
      { [GADimension.UIElementName]: packageName }
    );

    crmZoneView(
      {},
      produce(context, (draft) => {
        draft.entities = draft.entities || [];
        draft.entities.push(crmZone({ zoneName }));
      })
    );
  }
};
